import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-header-zhanghaoxinxi",
  "use": "icon-right-header-zhanghaoxinxi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-header-zhanghaoxinxi\"><path d=\"M594.6 638.9l38 47.5-101.3 81.1c-11.1 8.9-26.9 8.9-38 0L392 686.4l38-47.5 82.3 65.9 82.3-65.9z m333.2 287.2H867c0-91-25.1-177.5-70.6-248.7-28.1-44-63.5-81.1-103.8-109.1l34.7-50c47 32.6 87.9 75.6 120.3 126.3 51.8 81.1 80.2 178.9 80.2 281.5zM297.4 518.4l34.7 50c-40.3 27.9-75.6 65.1-103.8 109.1-45.6 71.2-70.6 157.7-70.6 248.7H96.9c0-102.6 28.4-200.4 80.2-281.5 32.3-50.7 73.3-93.7 120.3-126.3z m214.9 12.5c-128.7 0-233.1-104.3-233.1-233.1S383.6 64.7 512.3 64.7 745.4 169 745.4 297.8 641 530.9 512.3 530.9z m0-60.8c95.1 0 172.3-77.1 172.3-172.3s-77.1-172.3-172.3-172.3S340 202.7 340 297.8s77.1 172.3 172.3 172.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/right-header-zhanghaoxinxi.svg
// module id = TUkR
// module chunks = 8